import { getCookie } from '@utiljs/cookie';
import { stringify } from '@utiljs/param';
import { getEnv } from '@/utils';
import { AcctLoginTypeenums } from '@/pages/Client/api';

const env = getEnv();

const commonParams = {
    providerId: +getCookie('serviceProviderID'),
    providerName: getCookie('serviceProviderName') || '',
    token: decodeURIComponent(getCookie('token') || ''),
    providerRole: parseInt(getCookie('e_parent_acct_id'), 10) || 0, // 服务商角色  0-服务商，1-普通员工
    acctLoginType: parseInt(getCookie('e_acct_login_type'), 10) || AcctLoginTypeenums.PROVIDER, // 服务商角色  1-服务商，2-客服，3-创作者, 4-客服
    userMenuType: getCookie('e_user_menu_type') || 0,
};

/** 创作者 */
export const isCreator = commonParams.acctLoginType === AcctLoginTypeenums.CREATOR;
/** 外部客服 */
export const isOutCustomerService =
    commonParams.acctLoginType === AcctLoginTypeenums.OUT_CUSTOMER_SERVICE;
export const isMenuGray = commonParams.userMenuType === '1' ? true : false;

export default {
    commonParams,
    // 获取直播相关地址
    getLiveUrl(liveObj: any) {
        // 下面的是商家端H5页面地址
        const envMap: any = {
            test: 'http://e.proxy.waimai.test.sankuai.com/wmeactivity/marketLive',
            stage: 'https://proxy.waimai.st.sankuai.com/wmeactivity/marketLive',
            prod: 'https://waimaieapp.meituan.com/wmeactivity/marketLive',
        };
        // 回放完整流的地址
        const playbackStreamMap: any = {
            test: 'http://vod.inf.test.sankuai.com/recordings/mttest',
            stage: 'https://live-vod.meituan.net/recordings/mtwmlive',
            prod: 'https://live-vod.meituan.net/recordings/mtwmlive',
        };
        const paramStr = stringify(liveObj);
        const obj = {
            noticeUrl: `${envMap[env]}/notice?${paramStr}`,
            liveUrl: `${envMap[env]}/live?${paramStr}`,
            playbackUrl: `${envMap[env]}/playback?${paramStr}`,
            playbackStreamUri: `${playbackStreamMap[env]}/`, // 全部地址需要后面+stremId.m3u8
        };
        return obj;
    },
    // 根据推流链接，获取obs需要的服务地址、串流秘钥
    getPushUrl(pushUrl: string) {
        const obj = {
            serverUrl: '',
            key: '',
        };
        if (!pushUrl) {
            return obj;
        }
        const index = pushUrl.lastIndexOf('/');
        obj.serverUrl = pushUrl.substr(0, index + 1);
        obj.key = pushUrl.substr(index + 1);
        return obj;
    },
};
